import { Box, Typography } from "@mui/material";
import type { ReactNode } from "react";

/**
 * The explanatory panel above a blotter — what this surface covers, and what it deliberately does
 * not. Extracted from the Refunds panel when Invoices and Client Purchases needed the same thing;
 * three copies of the same styled Box was the alternative.
 */
export default function BlotterNote({ children }: { children: ReactNode }) {
  return (
    <Box
      sx={{
        mb: 2,
        p: "12px 16px",
        bgcolor: "var(--color-wax, #f7f5f0)",
        border: "1px solid var(--color-smoke)",
        borderRadius: "10px",
      }}
    >
      <Typography sx={{ fontSize: 13, color: "var(--color-graphite)", lineHeight: 1.5 }}>
        {children}
      </Typography>
    </Box>
  );
}
